import { logUsage } from 'owa-analytics';
import { type StateChangeSource } from '../types/StateChangeSource';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export const logLeftPaneStateChange = (
    showLeftPane: boolean,
    stateChangeSource: StateChangeSource
): void => {
    if (stateChangeSource === undefined) {
        return;
    }

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();

    const loggerMap: Partial<
        Record<StateChangeSource, (show: boolean, src: StateChangeSource) => void>
    > = {
        [1]: (show, src) =>
            logUsage('TnS_FolderPaneChange_MailList', mailboxInfo, [show, src], {
                isScorecardEvent: true,
            }),
        [0]: (show, src) =>
            logUsage('TnS_FolderPaneChange_Tabs', mailboxInfo, [show, src], {
                isScorecardEvent: true,
            }),
        [2]: (show, src) => logUsage('TnS_FolderPaneChange_Shortcut', mailboxInfo, [show, src]),
        [3]: (show, src) =>
            logUsage('TnS_FolderPaneChange_RibbonViewTab', mailboxInfo, [show, src], {
                isScorecardEvent: true,
            }),
        [4]: (show, src) =>
            logUsage('TnS_FolderPaneChange_LeftNavToggleButton', mailboxInfo, [show, src]),
        [5]: (show, src) => logUsage('TnS_FolderPaneChange_LeftNavDrag', mailboxInfo, [show, src]),
        [6]: (show, src) =>
            logUsage('TnS_FolderPaneChange_WorkbenchView', mailboxInfo, [show, src]),
        [7]: (show, src) =>
            logUsage('TnS_FolderPaneChange_CalendarPriority', mailboxInfo, [show, src]),
        [8]: (show, src) =>
            logUsage('TnS_FolderPaneChange_ScreenOrientationChange', mailboxInfo, [show, src]),
        [9]: (show, src) =>
            logUsage('TnS_FolderPaneChange_CopilotChatDrawerExpanding', mailboxInfo, [show, src]),
        [10]: (show, src) =>
            logUsage('TnS_FolderPaneChange_CopilotChatDrawerCollapsing', mailboxInfo, [show, src]),
        [14]: (show, src) =>
            logUsage('TnS_FolderPaneChange_FolderSettings', mailboxInfo, [show, src]),
    };

    const logFn = loggerMap[stateChangeSource];
    if (logFn) {
        logFn(showLeftPane, stateChangeSource);
    }
};
